import { Card } from 'components/atoms';
import ListWrapper from 'components/molecules/list-wrapper/ListWrapper';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { ICashFlowForm } from 'services/cash-flow/types';

import { formatCurrency } from 'utils/global/currency.utils';
import { getMaxFormattedLength } from 'utils/global/getMaxFormattedLength.utils';

const CashFlowRepayments = () => {
  const { values, status } = useFormikContext<ICashFlowForm>();
  const { t } = useTranslation();

  const amountToRepaymentLength = getMaxFormattedLength(
    values.repayments ?? [],
    e => e?.amount
  );

  return (
    <ListWrapper
      style={{ paddingBottom: 100 }}
      items={values.repayments}
      isLoading={status.isLoading}
      item={(repayment, key) => (
        <Card
          key={key}
          header={repayment.repaymentSource.name}
          description={repayment.repaymentDocument.number.value}
          status={
            <div
              className='flex w-max font-bold items-center gap-4'
              style={{ fontSize: 18 }}>
              {formatCurrency(repayment.amount)}
              {/* <Button
                type='button'
                isClear
                variant={BUTTON_VARIANT.black}
                onlyIcon
                onClick={() =>
                  getRepaymentFile(repayment.repaymentDocument.fileName)
                }>
                <Button.Icon icon={<PiDownload />} />
                <Button.Text text={t('button.download')} />
              </Button> */}
            </div>
          }
        />
      )}
    />
    // <Table
    //   size="compact"
    //   data={{
    //     nodes: values.repayments
    //       .filter((r) => !!r)
    //       .map((repayment, key) => ({
    //         id: key,
    //         ...repayment,
    //       })),
    //   }}
    //   columns={[
    //     {
    //       label: t("input.label.settlement"),
    //       renderCell: ({ repaymentSource }) => (
    //         <TableItem>
    //           <TableItem.Text
    //             text={t(`enum.REPAYMENT_SOURCE.${repaymentSource.name}`) ?? "-"}
    //           />
    //         </TableItem>
    //       ),
    //     },
    //     {
    //       label: t("input.label.net"),
    //       renderCell: ({ amount }) => (
    //         <TableItem>
    //           <TableItem.Text
    //             text={formatCurrency(amount, {
    //               length: amountToRepaymentLength,
    //             })}
    //           />
    //         </TableItem>
    //       ),
    //     },
    //     {
    //       label: t("input.label.source"),
    //       renderCell: ({ repaymentSource }) => (
    //         <TableItem>
    //           <TableItem.Text
    //             text={t(`enum.REPAYMENT_SOURCE.${repaymentSource.name}`) ?? "-"}
    //           />
    //         </TableItem>
    //       ),
    //     },
    //     {
    //       label: t("input.label.documentNumber"),
    //       renderCell: ({ repaymentDocument }) => (
    //         <TableItem>
    //           <TableItem.Text text={repaymentDocument.number.value ?? "-"} />
    //         </TableItem>
    //       ),
    //     },
    //     {
    //       label: "",
    //       renderCell: ({ repaymentDocument }) => (
    //         <TableItem justifyPosition="end">
    //           <a
    //             href={repaymentDocument.path ?? ""}
    //             download={repaymentDocument.path}
    //             aria-disabled={!repaymentDocument.path}
    //             target="_blank"
    //             rel="noreferrer"
    //           >
    //             <Button
    //               type="button"
    //               isClear
    //               onlyIcon
    //               disabled={!repaymentDocument.path}
    //             >
    //               <Button.Icon icon={<PiDownload />} />
    //             </Button>
    //           </a>
    //         </TableItem>
    //       ),
    //     },
    //   ]}
    // />
  );
};

export default CashFlowRepayments;
